import { Userpilot } from 'userpilot';

import { ZOLL_ONLINE } from '@/constants';
import { container } from '@/container';
import { UserController } from '@/controllers/UserController';
import { Connection } from '@/services/Connection';
import { Environment } from '@/services/Environment';
import { RouterGuard } from '@/services/router/types';
import { pathJoin } from '@/utils/pathJoin';

export const userPilotGuard: RouterGuard = async function userPilotGuard(to, from, next) {
  const connection = await container.getAsync(Connection);
  const userController = await container.getAsync(UserController);
  const environment = await container.getAsync(Environment);

  if (connection.success) {
    Userpilot.identify(
      userController.activeUser.userKey,
      {
        name: userController.activeUser.fullName,
        email: userController.activeUser.userName,
        company: // optional
                    {
                      id: userController.activeUser.tenantKey, // Company Unique ID
                      name: userController.activeUser.tenantName,
                    },
        // Additional user properties
        // plan: user.plan,
        // trialEnds: user.trial_ends ISO8601 Date
      },
    );

    return next();
  }

  window.location.replace(pathJoin(environment.zoBaseUrl, ZOLL_ONLINE.LOGIN_PATH));
  return next(false);
};
